import { useMutation } from '@tanstack/react-query';

type BulkDeleteRequest = {
  ids: number[];
};

export default function useBulkDeleteCompanies() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: BulkDeleteRequest) => {
      const response = await fetch('/agent/api/companies/bulk_destroy', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || '企業の削除に失敗しました');
      return data;
    },
  });
}
